module.exports='<div class="panel message J-message-target Hide">{{ it.forEach(function(item){ }}<a href="{{=item.link}}" data-click-name="{{= item.text}}" target="_blank">{{=item.text}}<strong>{{=item.count}}</strong></a>{{ }); }}<a class="ignore J-ignore">全部忽略</a></div>';


// WEBPACK FOOTER //
// ./modules/tpl/message-list.html.js